import React from "react";

export default function Body({ invoice }) {
  return (
    <div className="paymentInvoice_body">
      <div className="invoiceBody_block invoiceBody_prop">
        <span>Enterprise</span>
        <span>Team</span>
        <span>Enrollment Cycle</span>
        <span>Payment Period</span>
      </div>
      <div className="invoiceBody_block invoiceBody_value">
        <span>{invoice.attributes.enterprise}</span>
        <span>{invoice.attributes.team}</span>
        <span>{invoice.attributes.cycles}</span>
        <span>{invoice.attributes.payment_period}</span>
      </div>
    </div>
  );
}
